/**
 * Unlink Content UseCase
 *
 * Removes the link between a media item and its peer.
 * Mirrors Flutter MediasRepository.unlinkContent
 * (lib/data/repository/medias_repository.dart:349).
 */

import { MediaService } from '@/domain/services/media/mediaService';
import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';
import { appLogger } from '@/domain/services/analytics/appLogger';

export class UnlinkContentUseCase {
  private mediaService: MediaService;

  constructor(mediaService?: MediaService) {
    this.mediaService = mediaService || new MediaService();
  }

  /** Returns the peer media id on success, or null on failure. */
  async execute(source: UserMediaEntity): Promise<string | null> {
    try {
      return await this.mediaService.unlinkContent(source);
    } catch (error) {
      appLogger.error('Error unlinking content', 'UnlinkContentUseCase.execute', { error: error as Error });
      return null;
    }
  }
}

export const unlinkContentUseCase = new UnlinkContentUseCase();
